import { customAxiosInstanceMutator } from './custom-axios-instance';

/**
 * Loan details update types
 */
export type SecurityType = 'SECURED' | 'UNSECURED';
export type RepaymentFrequencyType = 'FIFTEEN_DAYS' | 'MONTHLY' | 'BI_MONTHLY' | 'QUARTERLY' | 'CUSTOM';
export type CalculationMode = 'AUTOMATIC' | 'CUSTOM';
export type CustomLoanType = 'ONCE_OFF' | 'INSTALLMENTS';

export interface LoanDetailsRequest {
  loanAmount: number;
  loanTerms: number;
  loanPurpose: string;
  interestRate?: number;
  securityType?: SecurityType;
  adminFee?: number;
  interestAmount?: number;
  totalRepayment?: number;
  dueDate?: string;
  repaymentFrequency?: RepaymentFrequencyType;
  calculationMode?: CalculationMode;
  customLoanType?: CustomLoanType;
  commencementDate?: string;
  numberOfInstallments?: number;
  paymentDates?: string[];
}

/**
 * Update loan details for a loan application
 * @summary PUT /loan/api/v1/loan-applications/{id}/loan-details
 */
export const updateLoanDetails = (
  applicationId: string,
  data: LoanDetailsRequest,
  signal?: AbortSignal
) => {
  return customAxiosInstanceMutator<any>(
    {
      url: `/loan/api/v1/loan-applications/${applicationId}/loan-details`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data,
      signal
    },
  );
};
